import { render, staticRenderFns } from "./DonutChart80.vue?vue&type=template&id=ff09b4fc&scoped=true&"
import script from "./DonutChart80.vue?vue&type=script&lang=js&"
export * from "./DonutChart80.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff09b4fc",
  null
  
)

export default component.exports